import { React, useState, useEffect, useRef, useCallback } from "react";
import "./Dashboard.css";
import Sidebar from "../Depreciated/Sidebar/Sidebar";
import { getCurrentBuilding, getUserPermissions } from "../../utils/AuthUtilities";
import AlertService from "../../services/AlertService";
// import MainDash from "../MainDash/MainDash";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
//import Contractors from "./Contractors";
//import Profile from "./Profile";
//import PersonalInfo from "./PersonalInfo";
//import Settings from "./Settings";
// import Tenants from "./Tenants";
//import RequestHistory from "./RequestHistory";
//import AlertHistory from "./AlertHistory";
//import TenantList from "./TenantList";
//import ContractorList from "./ContractorList";
import NewHome from "../MainDash/NewHome";
//import AlertsManagement from "../AlertManagement/AlertsManagement";
// import Sensors from "../MainDash/Sensors";
//import UtilityBill from "../Depreciated/UtilityBill";
//import Notifications from "./Notifications";
//import CreateRequest from "../RequestManagement/CreateRequest";
//import AlertManagement from "../AlertManagement/AlertManagement";
//import RequestManagement from "../RequestManagement/RequestManagement";
//import Requests from "../RequestManagement/Requests";
//import CompletedAlerts from "../AlertManagement/CompletedAlerts";
//import CompletedRequests from "../RequestManagement/CompletedRequests";
// import AlertReview from "../MainDash/AlertReview";
import HealthSafetyAlerts from "../MainDash/Alerts/HealthSafetyAlerts";
import ResourceEfficiency from "../MainDash/Alerts/ResourceEfficiency";
import ServiceCheck from "../MainDash/Alerts/ServiceCheck";
import AlertInfoPage from "../MainDash/Alerts/AlertInfoPage";
import AlertDetailsPage from "../MainDash/Alerts/AlertDetailsPage";
import ResourceEffectiveness from '../MainDash/BenefitTracker/ResourceEffectiveness';
import OccupantSatisfaction from "../MainDash/BenefitTracker/OccupantSatisfaction";
import OperationalEfficiency from "../MainDash/BenefitTracker/OperationalEfficiency";
import BenefitGoals from "../MainDash/BenefitTracker/BenefitGoals";
import Feedback from "../Menu/Feedback";
import SubmitPage from "../Menu/Submit/SubmitPage";
import Profile from "../Menu/Manage/Profile";
import BuildingInfo from "../Menu/Manage/BuildingInfo";
import Tenants from "../Menu/Manage/Tenants";
import Contractors from "../Menu/Manage/Contractors";
import Buildings from "../Menu/Manage/Buildings";
import DataPage from "../Menu/Manage/DataPage";
import Menu from "../Menu/Menu";
import Refer from "../Menu/Refer";
import Vault from "../Menu/Submit/Vault";
import UtilityBills from "../Menu/Submit/UtilityBills";
import BuildingMenu from "../Menu/BuildingMenu";
import AlertsAnalysis from "../Menu/Analysis/Alerts";
import AssetAnalysis from "../Menu/Analysis/Asset";
import WhatIfAnalysis from "../Menu/Analysis/WhatIf";
import UtilityAnalysis from "../Menu/Analysis/Utility";
import ContractorAnalysis from "../Menu/Analysis/Contractor";
import ServiceAnalysis from "../Menu/Analysis/Service";
import NoBuildings from "../Login/NoBuildings";
import ComingSoon from "../Menu/ComingSoon";
import Header from "../Header";

//import { checkCookieExpiration } from "../AuthUtilities";
// import Test from "../MainDash/Test";

function Dashboard() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isBuildingMenuOpen, setBuildingMenuOpen] = useState(false);
  const [buildingPaused, setBuildingPaused] = useState(false);
  const [pausedMessage, setPausedMessage] = useState("");
  // const [title, setTitle] = useState("Home");
  const history = useHistory();
  const location = useLocation();
  const lastHiddenTime = useRef(null);

  const toggleMenu = () => {
    if (isBuildingMenuOpen) {
      setBuildingMenuOpen(false);
    }
    setShowMenu(!showMenu);
  };

  const toggleBuildingMenu = () => {
    if (showMenu) {
      setShowMenu(false);
    }
    setBuildingMenuOpen(!isBuildingMenuOpen);
  };

  // useEffect(() => {
  //   const isTokenExpired = checkCookieExpiration();
  //   if (isTokenExpired) {
  //     history.push("/"); // Redirect to login or home
  //   }
  // }, [history]);

  // Pause gate: check if the current building is paused for non-admin users
  // currentBuilding from localStorage can be full object (login) or just id string (after switching in BuildingMenu)
  // Re-run when tab becomes visible so users see the banner soon after an admin pauses (without refreshing).
  const checkPauseStatus = useCallback(async () => {
    const permissions = getUserPermissions();
    if (permissions === 'admin') return; // Admins bypass the pause gate

    const currentBuilding = getCurrentBuilding();
    const buildingId = currentBuilding
      ? (typeof currentBuilding === 'object' && currentBuilding._id
          ? currentBuilding._id
          : typeof currentBuilding === 'string'
          ? currentBuilding
          : null)
      : null;
    if (!buildingId) return;

    try {
      const building = await AlertService.getBuildingById(buildingId);
      if (building?.options?.servicesPaused) {
        setBuildingPaused(true);
        setPausedMessage(building.options.servicesPausedMessage || '');
      } else {
        setBuildingPaused(false);
        setPausedMessage('');
      }
    } catch (err) {
      // If the API returns 423, the building is paused
      if (err?.response?.status === 423) {
        const data = err.response.data;
        setBuildingPaused(true);
        setPausedMessage(data?.message || '');
      }
    }
  }, []);

  useEffect(() => {
    checkPauseStatus();
  }, [checkPauseStatus]);

  // Re-run pause check when user navigates to /Home (e.g. from Manage, Alerts, etc.)
  // Closes the gap when the app stays open in a dedicated window with no tab switching.
  useEffect(() => {
    if (location.pathname === '/Home') {
      checkPauseStatus();
    }
  }, [location.pathname, checkPauseStatus]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkPauseStatus();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [checkPauseStatus]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        // Store the timestamp when the user leaves
        lastHiddenTime.current = Date.now();
      } else if (document.visibilityState === "visible") {
        // Calculate time away
        const timeAway = Date.now() - lastHiddenTime.current;
        const secondsAway = timeAway / 1000;

        console.log(`User was away for ${secondsAway} seconds`);

        // If away for more than 30 seconds, reload
        if (secondsAway > 600) {
          console.log("Reloading after extended inactivity...");
          history.push("/Home"); // Navigate to homepage
          window.location.reload();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [history]);

  // Pause gate banner – blurred overlay and card in app style
  if (buildingPaused) {
    const currentBuilding = getCurrentBuilding();
    const buildingName = currentBuilding && typeof currentBuilding === 'object' ? currentBuilding.name : null;
    return (
      <>
        <div className="min-h-screen">
          <Header
            onMenuClick={toggleMenu}
            onBuildingClick={toggleBuildingMenu}
            isMenuOpen={showMenu}
            isBuildingMenuOpen={isBuildingMenuOpen}
          />
          <Menu show={showMenu} setter={setShowMenu} onClose={() => setShowMenu(false)} />
          <BuildingMenu show={isBuildingMenuOpen} setter={setBuildingMenuOpen} />
          <div className="parent-container flex">
            <Sidebar className="sidebar" show={showSidebar} setter={setShowSidebar} />
            <div className="sidebar-content" style={{ overflowY: "scroll", height: "92dvh" }} />
          </div>
        </div>
        <div className="pause-banner-overlay" aria-modal="true" role="dialog" aria-labelledby="pause-banner-title">
          <div className="pause-banner-card">
            <div className="pause-banner-header" id="pause-banner-title">
              <span aria-hidden="true">🚧</span>
              Services Paused
            </div>
            <div className="pause-banner-body">
              <p className="pause-banner-message">
                {pausedMessage ||
                  "Services for this building have been temporarily paused by an administrator. Please check back later."}
              </p>
              {buildingName && (
                <p className="pause-banner-building">
                  Building: <strong>{buildingName}</strong>
                </p>
              )}
            </div>
            <div className="pause-banner-actions">
              <button type="button" className="pause-banner-btn-switch" onClick={() => setBuildingMenuOpen(true)}>
                Switch Building
              </button>
              <button
                type="button"
                className="pause-banner-btn-logout"
                onClick={() => {
                  localStorage.removeItem("isLoggedIn");
                  localStorage.removeItem("loginResponse");
                  localStorage.removeItem("loginTimestamp");
                  localStorage.removeItem("token");
                  localStorage.removeItem("currentBuilding");
                  history.push("/");
                  window.location.reload();
                }}
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div>
       <div className="min-h-screen">
       <Header 
          onMenuClick={toggleMenu} 
          onBuildingClick={toggleBuildingMenu} 
          isMenuOpen={showMenu} 
          isBuildingMenuOpen={isBuildingMenuOpen} 
        />
       <Menu show={showMenu} setter={setShowMenu} onClose={() => setShowMenu(false)}/>
       <BuildingMenu show={isBuildingMenuOpen} setter={setBuildingMenuOpen}/>
        <div className="parent-container flex">
          <div className="md:hidden">
          </div>
          <Sidebar className='sidebar' show={showSidebar} setter={setShowSidebar} />
          <div className="sidebar-content" style={{overflowY: 'scroll', height: '92dvh'}}>
            <Switch>
              <Route path="/Home" component={NewHome} />
              {/* <Route path="/Sensors" component={Sensors} /> */}
              {/* <Route path="/MainDash" component={MainDash} /> */}
              {/* <Route path="/contractors" component={Contractors} /> */}
              {/* <Route path="/requesthistory" component={RequestHistory} /> */}
              {/* <Route path="/alerthistory" component={AlertHistory} /> */}
              {/* <Route path="/tenants" component={Tenants} /> */}
              {/* <Route path="/profile" component={Profile} />
              <Route path="/notifications" component={Notifications} />
              <Route path="/personal" component={PersonalInfo} /> */}
              {/* <Route path="/tenantlist" component={TenantList} /> */}
              {/* <Route path="/contractorlist" component={ContractorList} /> */}
              {/* <Route path="/settings" component={Settings} /> */}
              {/* <Route path="/utility" component={UtilityBill} /> */}
              {/* <Route path="/test" component={Test} /> */}
              <Route path="/HealthSafety" component={HealthSafetyAlerts} />
              <Route path="/ResourceEfficiency" component={ResourceEfficiency} />
              <Route path="/ServiceCheck" component={ServiceCheck} />
              <Route exact path="/AlertInfo/:id" component={AlertInfoPage} />
              <Route path="/alert/:id/details" component={AlertDetailsPage} />
              <Route path="/NoBuildings" component={NoBuildings} />
              <Route path="/ResourceEffectiveness" component={ResourceEffectiveness} />
              <Route path="/OccupantSatisfaction" component={OccupantSatisfaction} />
              <Route path="/OperationalEfficiency" component={OperationalEfficiency} />
              <Route path="/BenefitGoals" component={BenefitGoals} />
              <Route path="/Feedback" component={Feedback} />
              <Route path="/SubmitPage" component={SubmitPage} />
              <Route path="/Profile" component={Profile} />
              <Route path="/BuildingInfo" component={BuildingInfo} />
              <Route path="/Tenants" component={Tenants} />
              <Route path="/Contractors" component={Contractors} />
              <Route path="/Buildings" component={Buildings} />
              <Route path="/DataPage/:type/:id" component={DataPage} />
              <Route path="/ComingSoon/:title" component={ComingSoon} />
              <Route path="/Analysis/Alerts" component={AlertsAnalysis} />
              <Route path="/Analysis/Asset" component={AssetAnalysis} />
              <Route path="/Analysis/WhatIf" component={WhatIfAnalysis} />
              <Route path="/Analysis/Utility" component={UtilityAnalysis} />
              <Route path="/Analysis/Contractor" component={ContractorAnalysis} />
              <Route path="/Analysis/Service" component={ServiceAnalysis} />
              <Route path="/Refer" component={Refer}/>
              <Route path="/Vault" component={Vault}/>
              <Route path="/UtilityBills" component={UtilityBills}/>
             {/* Contractor */}
              {/* <Route path="/alerts/manage" component={AlertManagement} /> */}
              {/* <Route path="/alerts/review/:alertId" component={AlertReview} /> */}
              {/* <Route path="/alerts/new" component={AlertsManagement}
                render={(props) => <AlertsManagement {...props} inProgress={true} />}
              /> */}
              {/* <Route path="/alerts/in-progress" component={AlertsManagement}
                render={(props) => <AlertsManagement {...props} inProgress={true} />}
              /> */}
              {/* <Route path="/alerts/completed" component={CompletedAlerts} />
              <Route path="/requests/manage" component={RequestManagement} />
              <Route path="/requests/completed" component={CompletedRequests} />
              <Route path="/requests/new" component={CreateRequest} />
              <Route path="/requests/in-progress" component={Requests}
                render={(props) => <Requests {...props} inProgress={true} />}
              />
              <Route path="/requests/requests" component={Requests}
                render={(props) => <Requests {...props} inProgress={false} />}
              /> */}
            </Switch>
          </div> 
        </div>
      </div> 
    </div>
  );
}

export default Dashboard;
